import React, { useState, useRef } from "react";
import { Form, FormGroup } from "reactstrap";
import { Btn, Image } from "../AbstractElements";
import Spinner from "../Components/Common/Component/Spinner";
import { VerifyCode } from "../Constant";
import useAuth from "../Hooks/useAuth";
import { toast } from 'react-toastify';
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const TotpForm = ({ onSubmit, useEmail, displayImage = false}) => {
    const axiosPrivate = useAxiosPrivate()
  const [totp, setTotp] = useState(["", "", "", "", "", ""]);
  
  const inputs = useRef([]);
  const [loading, setLoading] = useState(false);
  const { auth0_profile } = useAuth();
  
  const handleChange = (e, index) => {
    let value = e.target.value;
    
    if (value.length > 1) {
      value = value[0]; // Allow only one digit to be entered
    }

    // Update the specific TOTP digit in the array
    const newTotp = [...totp];
    newTotp[index] = value;
    setTotp(newTotp);

    // Move focus to the next input if a digit is entered
    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Handle backspace behavior to go to the previous input
    if (e.key === "Backspace" && index > 0 && totp[index] === "") {
      inputs.current[index - 1].focus();
    }
  };

  const handleVerify2FA = async (e) => {
    e.preventDefault();
    
    try {
        setLoading(true); 

        let email;

        if(auth0_profile){
          email = auth0_profile.email;
        }
        else if(useEmail){
          email = useEmail;
        } else {
          toast.error("No valid user found");
          return;
        }
        
        const otp = totp.join("");

        if (otp.length !== 6) {
            toast.error("Please enter a complete 6-digit OTP code.");
            return;
        }

        const response = await axiosPrivate.post('/auth/verify-2fa',
            JSON.stringify({ email, otp }),
          {
              headers: { 'Content-Type': 'application/json', },
              withCredentials: true
          } 
        );

        const data = response.data;
        if (data.status) {
            toast.success(data.data.message);
            onSubmit(response.data.status);
        }
    } 
    catch (error) {
        if (error.response && error.response.status === 422) {
          toast.error('Validation Errors');
        } else if ((error.response && error.response.status === 400) || (error.response && error.response.status === 404)) {
          toast.error(error.response.data.detail);
        } else {
          console.log(error);
          
          toast.error('Form submission error');
        }
    }
    /* catch (err) {
      
        if (!err?.response) {
            setErrMsg('No Server Response');
        } else if (err.response?.status === 422) {
            setErrMsg('Missing Username or Password');
        } else if (err.response?.status === 401) {
            setErrMsg('Unauthorized');
        } else if ((err.response && err.response.status === 400) || (err.response && err.response.status === 404)) {
            setErrMsg(err.response.data.detail);
        } else {
            setErrMsg('Login Failed');
        }
    }  */
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="totp-form">
     { displayImage && (
        <>
            <h4>Verification code</h4>
            <Image attrImage={{ className: 'img-fluid', src: `${require('../assets/images/authenticate.png')}`, alt: 'authenticate' }} />
        </>
     )}
      <h4>Your OTP Code here</h4>
      <Form className='theme-form login-form' onSubmit={handleVerify2FA}>
        <div className="totp-input-group">
          {totp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputs.current[index] = el)}
              className="totp-input"
            />
          ))}
        </div>
        <FormGroup>
            <Btn attrBtn={{ color: 'primary', 
            className: 'd-block w-100 mt-2', 
            disabled:loading }}>
            {loading ? <Spinner /> : `${VerifyCode}`}
            </Btn>
        </FormGroup>
      </Form>
    </div>
  );
};

export default TotpForm;
